export enum BadgeColor {
  LIME = 'lime',
  BERRY = 'berry',
  DARK_MINT = 'dark-mint',
  NONE = ''
}
